const MGGROUP = "MGGroup";
const MUTUAL = "Mutual18J";
const BDS = "BDS";

export const productores = {
  [MGGROUP]: "MG GROUP",
  [MUTUAL]: "MUTUAL",
  [BDS]: "BDS",
};
